import { OidcIdentityProviderDto, SamlIdentityProviderDto } from '../../../../../api-client';

export const isSamlProvider = (provider: SamlIdentityProviderDto | OidcIdentityProviderDto): provider is SamlIdentityProviderDto => {
  return (provider as SamlIdentityProviderDto).ssoUrl !== undefined;
}

export const isOidcProvider = (provider: SamlIdentityProviderDto | OidcIdentityProviderDto): provider is OidcIdentityProviderDto => {
  return (provider as OidcIdentityProviderDto).clientId !== undefined;
}
